module.exports = __webpack_public_path__ + "static/media/nima_walking_new11b.3f6eafba.gif";